import React, { useEffect, useRef } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Swiper as SwiperType } from "swiper";
import { Navigation, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import styles from "./RecentCatchGallery.module.css";
import cn from 'classnames';
import { Image } from "react-bootstrap";
import { ASSESTS } from "../../../../../../../constant/assest";
import RecentCatchCard from "../../../../../../../component/UI/RecentCatchCard/RecentCatchCard";
import RecentCatchCardSkeleton from "../../../../../../../component/UI/RecentCatchCardSkeleton/RecentCatchCardSkeleton";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../../../../../redux/store";
import { fetchUserRecentCatches } from "../../../../../../../redux/slices/portfolio/actions";

interface IProps {
    userId: string;
};

const RecentCatchGallery: React.FC<IProps> = (userId) => {
    const dispatch = useDispatch<AppDispatch>();
    const {recentCatches , recentCatchesLoading}= useSelector((state: RootState)=> state.portfolio);
    const slides = recentCatches;
    const swiperRef = useRef<SwiperType | null>(null);

    useEffect(() => {
        dispatch(fetchUserRecentCatches({ userId: userId.userId, page: 1, limit: 20 }));
    },[dispatch, userId.userId])

    return (
        <>
            <div className={cn(styles.sliderWrapper)}>
                <Swiper
                    modules={[Navigation, Pagination]}
                    spaceBetween={20}
                    slidesPerView={1}
                    navigation={{
                        nextEl: ".button-next",
                        prevEl: ".button-prev",
                    }}
                    pagination={{ el: ".swiper-pagination", clickable: true }}
                    onSwiper={(swiper: SwiperType) => (swiperRef.current = swiper)}
                    className={styles.allSlides}
                    breakpoints={{
                        640: {
                            slidesPerView: 1,
                            spaceBetween: 20,
                        },
                        768: {
                            slidesPerView: 2,
                            spaceBetween: 25,
                        },
                        1024: {
                            slidesPerView: 3,
                            spaceBetween: 25,
                        },
                        1299: {
                            slidesPerView: 3,
                            spaceBetween: 35,
                        },
                        1599: {
                            slidesPerView: 3,
                            spaceBetween: 53,
                        },
                    }}
                >
                    {recentCatchesLoading === 'pending' ? (
                        Array.from({ length: 3 }).map((_, index) => (
                            <SwiperSlide key={index} className={styles.slidesItem}>
                                <RecentCatchCardSkeleton />
                            </SwiperSlide>
                        ))
                    ) : slides && slides.transformed.length > 0 ? (
                        slides?.transformed.map((item) => (
                            <SwiperSlide key={item.id} className={styles.slidesItem}>
                                <RecentCatchCard 
                                    featureImage={item.uploads.images[0].imageUrl || ASSESTS.FISHINGDUMMY} 
                                    title={item.name} 
                                    weight={item.weight} 
                                    length={item.length} 
                                    location={item.locaption} 
                                    date={item.date} 
                                    weather={item.weather} 
                                />
                            </SwiperSlide>
                        ))
                    ) : (
                        <div className={styles.noCatches}>No Recent Catches Found</div>
                    )}
                </Swiper>

                {/* Bottom Controls */}
                <>
                    <button className={cn("button-prev", styles.slideBtn, styles.slideBtnLeft)}>
                        <Image src={ASSESTS.PREVSLIDE} alt={'Prev'} />
                    </button>
                    <button className={cn("button-next", styles.slideBtn, styles.slideBtnRight)}>
                        <Image src={ASSESTS.NEXTSLIDE} alt={'Prev'} />
                    </button>
                </>
            </div>
        </>
    );
};

export default React.memo(RecentCatchGallery);
